export var DISPLAYER_MODE;
(function (DISPLAYER_MODE) {
    DISPLAYER_MODE["DM_1D"] = "1D";
    DISPLAYER_MODE["DM_2D"] = "2D";
})(DISPLAYER_MODE || (DISPLAYER_MODE = {}));
export const MARGIN = {
    '2D': { top: 100, right: 50, bottom: 70, left: 100 },
    '1D': {
        top: 10,
        right: 10,
        bottom: 50,
        left: 10,
    },
};
